import React from 'react';

export function useAutoHide(onClose?: () => void, duration: number = 1200): [boolean, () => void] {
  const [isOpen, setOpen] = React.useState(false);

  const closeDialog = React.useCallback(() => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  React.useEffect(() => {
    if (isOpen) {
      const handle = setTimeout(closeDialog, duration);
      return () => {
        clearTimeout(handle);
      };
    }
  }, [isOpen, closeDialog, duration]);

  const openDialog = () => setOpen(true);

  return [isOpen, openDialog];
}
